import React, { useState } from 'react'
import { PropagateLoader } from 'react-spinners'
import DataTables from '../LMS_DATA_TABLE/DataTable'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { certificateListRes, certificateListTodo } from '../../LMS_Redux/LMS_Slices/Certificate/CertificateList'
import { IoInformationCircleOutline } from "react-icons/io5";
import { Tooltip } from 'react-tooltip'
import { getCertificateRes, getCertificateTodo } from '../../LMS_Redux/LMS_Slices/Course/GetCertificate'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

export default function CertificateList() {

    const [loading, setLoading] = useState(false)
    const [bool, setBool] = useState(false)
    const dispatch = useDispatch()
    const certificate = useSelector(state => state.certificateList && state.certificateList.data && state.certificateList.data.data)
    // console.log(certificate)

    let user_id = JSON.parse(localStorage.getItem('user_data'))

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'LEARNING MODULE',
            field: 'lms_master_course.course_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'TRAINING NAME',
            field: 'lms_training.training_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'RESULT STATUS',
            field: 'result_status',
            cellRenderer: params => params.value == 'pass' ? <span className='badge text-bg-success text-capitalize'>{params.value}</span> : <span className='badge text-bg-danger text-capitalize'>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            headerName: 'GENERATED ON',
            field: 'updatedAt',
            filter: 'agDateColumnFilter',
            valueFormatter: function (params) {
                return new Date(params.value).toLocaleDateString('en-GB')
            },
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    var format = cellValue.split('T')[0]

                    if (format == null) { return 0 };

                    const dateParts = format.split('-');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(day, month, year);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'ACTIONS',
            field: 'res_certificate',
            cellRenderer: params =>
                <div>
                    {params.data.result_status == 'pass' ?
                        params.data.res_certificate == ''  || params.data.res_certificate == null ?
                        <span style={{ cursor: 'pointer' }}>
                            <IoInformationCircleOutline size={20} className='eye'
                                onClick={() => genratePdf(params.data)}
                                data-tooltip-id='details'
                                data-tooltip-content="View Certificate!"
                                data-tooltip-place="bottom"
                            />
                        </span>
                        :
                        <a href={process.env.REACT_APP_IMAGE_URL + params.value} target="_blank" >
                            <IoInformationCircleOutline size={20} className='eye'
                                // onClick={() => msg_details(params)}
                                data-tooltip-id='details'
                                data-tooltip-content="View Certificate!"
                                data-tooltip-place="bottom"
                            />
                        </a>
                        : ''
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ])


    const genratePdf = (data) => {
        dispatch(getCertificateTodo(data)).then(() => getCertificate_res())
        Swal.fire({
            title: 'Hold on...',
            text: "We're generating your certificate!..",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    }

    const getCertificate_res = () => {
        if (getCertificateRes && getCertificateRes.success) {
            Swal.close();
            window.open(process.env.REACT_APP_IMAGE_URL + getCertificateRes?.data, 'target_blank')
            toast.success(getCertificateRes.message, { position: "bottom-right" })
            setBool(!bool)
        } else {
            Swal.close();
            toast.error(getCertificateRes.message, { position: "bottom-right" })
        }
    }

    const certificate_res = () => {
        if (certificateListRes && certificateListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(certificateListTodo(user_id.vemp_code)).then(() => certificate_res())
    }, [bool])


    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Certificates Management / </span>
                    <span className='icon2'>Certificate List</span>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    certificate && certificate.length ?
                        <DataTables
                            rowData={certificate}
                            columnDefs={columnDefs}
                        />
                        :
                        <div className='wrapper-admin'>
                            <div className='text-center'>
                                <h5>Certificate List Not Found</h5>
                            </div>
                        </div>
                }
            </div>
        </>
    )
}
